import { __awaiter, __generator, __assign } from '../../node_modules/tslib/tslib.es6.js';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { styled, Grid, IconButton } from '@mui/material';
import _toNumber from 'lodash/toNumber';
import React, { useState, useEffect } from 'react';
import '../../api/graphQl/brand.js';
import { ProductOperation, UNAUTHENTICATED_SEARCH_PRODUCTS } from '../../api/graphQl/product.js';
import { TABLET_SCREEN_SIZE, WIDGET_SPACE, WIDGET_SPACE_HALF, MOBILE_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING } from '../../utils/constants/Constants.js';
import { GenericContainer } from '../components/GenericContainer.js';
import SearchProductGrid from '../SearchResults/SearchProductGrid.js';
import { BrandclubPageType } from '@brandclub/types';
import { BrandclubBreadcrumbs } from '../components/BrandclubBreadcrumbs/BrandclubBreadcrumbs.js';

var _a, _b;
var PAGE_SIZE = 20;
var POPULAR_PRODUCTS_LABEL = 'Popular Products';
var PaginationContainer = styled('div')((_a = {
        textAlign: 'right'
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        fontSize: 20,
    },
    _a));
var Title = styled('div')({
    marginBottom: 30,
});
var PopularProductsContainer = styled(GenericContainer, {
    shouldForwardProp: function (prop) { return !['widthOverride'].includes(prop.toString()); },
})(function (_a) {
    var _b;
    var widthOverride = _a.widthOverride, theme = _a.theme;
    return (_b = {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: WIDGET_SPACE,
            paddingBottom: WIDGET_SPACE,
            paddingLeft: widthOverride ? 0 : '5%',
            paddingRight: widthOverride ? 0 : '5%',
            boxSizing: 'border-box',
            color: theme.palette.primary.main
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            backgroundColor: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px ").concat(MOBILE_HORIZONTAL_PADDING, "px"),
        },
        _b);
});
var ContentWrapper = styled(Grid)((_b = {
        maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
        width: '100%'
    },
    _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {},
    _b));
var PopularProducts = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    var mainEntity = _a.mainEntity, LinkComponent = _a.LinkComponent, apolloClient = _a.apolloClient, pageContext = _a.pageContext, cmsPage = _a.page, useSearchParams = _a.useSearchParams, onShareClick = _a.onShareClick, routePrefix = _a.routePrefix;
    var _v = useState([]), popularProducts = _v[0], setPopularProducts = _v[1];
    var _w = useSearchParams(), searchParams = _w[0], setSearchParams = _w[1];
    var _x = useState(true), loading = _x[0], setLoading = _x[1];
    var _y = useState(0), totalResultCount = _y[0], setTotalResultCount = _y[1];
    var page = _toNumber(searchParams.get('page'));
    var movePrev = function () {
        searchParams.set('page', "".concat(page - PAGE_SIZE));
        setSearchParams(searchParams);
    };
    var moveNext = function () {
        searchParams.set('page', "".concat(page + PAGE_SIZE));
        setSearchParams(searchParams);
    };
    useEffect(function () {
        if (mainEntity && mainEntity.entity) {
            var fetchProducts = function () { return __awaiter(void 0, void 0, void 0, function () {
                var searchRequestBody, treatment, data;
                var _a, _b, _c, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            setLoading(true);
                            searchRequestBody = {
                                sort: [
                                    {
                                        fieldName: 'searchScore',
                                        direction: 'desc',
                                    },
                                ],
                            };
                            if (mainEntity.type === 'brand') {
                                searchRequestBody.brandIds = [parseInt("".concat(mainEntity.id))];
                                // apply category / subcategory filter
                                if (pageContext.subCategoryId && !isNaN(parseInt("".concat(pageContext.subCategoryId)))) {
                                    searchRequestBody.subCategoryIds = [parseInt("".concat(pageContext.subCategoryId))];
                                }
                                if (pageContext.categoryId && !isNaN(parseInt("".concat(pageContext.categoryId)))) {
                                    searchRequestBody.categoryIds = [parseInt("".concat(pageContext.categoryId))];
                                }
                            }
                            if (mainEntity.type === 'product') {
                                searchRequestBody.brandIds = [parseInt("".concat(mainEntity.entity.brandId))];
                                searchRequestBody.categoryIds = [parseInt("".concat(mainEntity.entity.categoryId))];
                            }
                            treatment = (pageContext === null || pageContext === void 0 ? void 0 : pageContext.abTestingTreatments) && (pageContext === null || pageContext === void 0 ? void 0 : pageContext.abTestingTreatments.searchImprovementTreatment)
                                ? {
                                    search: pageContext === null || pageContext === void 0 ? void 0 : pageContext.abTestingTreatments.searchImprovementTreatment,
                                }
                                : undefined;
                            return [4 /*yield*/, apolloClient.query({
                                    query: UNAUTHENTICATED_SEARCH_PRODUCTS,
                                    variables: __assign(__assign({}, searchRequestBody), { page: {
                                            start: page,
                                            size: PAGE_SIZE,
                                        }, computeFacets: true, treatment: treatment }),
                                })];
                        case 1:
                            data = (_e.sent()).data;
                            setTotalResultCount((_b = (_a = data === null || data === void 0 ? void 0 : data[ProductOperation.UnauthenticatedSearch]) === null || _a === void 0 ? void 0 : _a.totalProducts) !== null && _b !== void 0 ? _b : 0);
                            setPopularProducts((_d = (_c = data === null || data === void 0 ? void 0 : data[ProductOperation.UnauthenticatedSearch]) === null || _c === void 0 ? void 0 : _c.products) !== null && _d !== void 0 ? _d : []);
                            setLoading(false);
                            return [2 /*return*/];
                    }
                });
            }); };
            fetchProducts();
        }
    }, [mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.id, searchParams, cmsPage.pageType, cmsPage.displayName]);
    var title = pageContext.subCategoryId || pageContext.categoryId
        ? ((_c = (_b = pageContext.subCategoryEntity) === null || _b === void 0 ? void 0 : _b.entity) === null || _c === void 0 ? void 0 : _c.subCategoryName) ||
            ((_e = (_d = pageContext.categoryEntity) === null || _d === void 0 ? void 0 : _d.entity) === null || _e === void 0 ? void 0 : _e.categoryName) ||
            cmsPage.displayName
        : POPULAR_PRODUCTS_LABEL;
    var hasResults = !loading && popularProducts.length;
    var widthOverride = !!((_f = cmsPage === null || cmsPage === void 0 ? void 0 : cmsPage.containerConfigOverride) === null || _f === void 0 ? void 0 : _f.width);
    var disableBack = page === 0;
    var totalPages = Math.ceil(totalResultCount / PAGE_SIZE);
    var disableNext = page + 1 >= totalPages;
    var breadcrumbs = [
        {
            label: (_g = mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.entity) === null || _g === void 0 ? void 0 : _g.name,
            to: routePrefix,
        },
    ];
    if (cmsPage.pageType === BrandclubPageType.Category) {
        breadcrumbs.push({
            label: (_j = (_h = pageContext.categoryEntity) === null || _h === void 0 ? void 0 : _h.entity) === null || _j === void 0 ? void 0 : _j.categoryName,
            to: routePrefix + "/categories/".concat((_l = (_k = pageContext.categoryEntity) === null || _k === void 0 ? void 0 : _k.entity) === null || _l === void 0 ? void 0 : _l.categoryId),
        });
    }
    if (cmsPage.pageType === BrandclubPageType.Subcategory) {
        breadcrumbs.push({
            label: (_o = (_m = pageContext.subCategoryEntity) === null || _m === void 0 ? void 0 : _m.entity) === null || _o === void 0 ? void 0 : _o.parentCategoryName,
            to: routePrefix + "/categories/".concat((_q = (_p = pageContext.subCategoryEntity) === null || _p === void 0 ? void 0 : _p.entity) === null || _q === void 0 ? void 0 : _q.parentCategoryId),
        });
        breadcrumbs.push({
            label: (_s = (_r = pageContext.subCategoryEntity) === null || _r === void 0 ? void 0 : _r.entity) === null || _s === void 0 ? void 0 : _s.subCategoryName,
            to: routePrefix + "/subcategories/".concat((_u = (_t = pageContext.subCategoryEntity) === null || _t === void 0 ? void 0 : _t.entity) === null || _u === void 0 ? void 0 : _u.subCategoryId),
        });
    }
    return (React.createElement(PopularProductsContainer, { style: title === POPULAR_PRODUCTS_LABEL ? {} : { paddingTop: '30px' }, widthOverride: widthOverride },
        React.createElement(ContentWrapper, null,
            React.createElement("div", null,
                React.createElement(Title, { className: "breadcrumbs" },
                    React.createElement(BrandclubBreadcrumbs, { items: breadcrumbs, LinkComponent: LinkComponent, maxWidth: 500 })),
                React.createElement(SearchProductGrid, { onShareClick: onShareClick, loading: loading, LinkComponent: LinkComponent, products: popularProducts, containerWidthOverride: widthOverride }),
                hasResults && (!disableBack || !disableNext) ? (React.createElement(PaginationContainer, null,
                    React.createElement(IconButton, { disableRipple: true, disableFocusRipple: true, onClick: movePrev, disabled: disableBack },
                        React.createElement(ChevronLeftIcon, { sx: function (theme) { return ({ color: theme.palette.primary.main, opacity: disableBack ? 0.5 : 1 }); } })),
                    React.createElement(IconButton, { disableRipple: true, disableFocusRipple: true, onClick: moveNext, disabled: disableNext },
                        React.createElement(ChevronRightIcon, { sx: function (theme) { return ({ color: theme.palette.primary.main, opacity: disableNext ? 0.5 : 1 }); } })))) : null))));
};

export { PopularProducts };
//# sourceMappingURL=index.js.map
